import { DimensionMetadata } from '@lib.core/entities/indicator/dimension-metadata';

export interface DimensionMetadataDetailDTO {
  sid: number;
  name: string;
  parent_sid: number;
  level: number;
  group_type: string;

  [detail: string]: number | string | number[] | string[];
}

export class DimensionMetadataDTO {
  nameid!: string;
  detail!: DimensionMetadataDetailDTO[];

  static toDimensionMetadata(dimensionMetadataDTO: DimensionMetadataDTO): DimensionMetadata {
    return new DimensionMetadata(
      dimensionMetadataDTO.nameid,
      dimensionMetadataDTO.detail.map(detail => (
        {
          ...detail,
          sid: detail.sid,
          name: detail.name,
          parentSid: detail.parent_sid,
          level: detail.level,
          groupType: detail.group_type,
        }
      ))
    );
  }
}
